import { RadioButton } from "@risalabs_frontend_org/oasis-ui-kit";
import { YES_NO_OPTIONS } from "../constants";

interface YesNoRadioProps {
  label: string;
  name: string;
  value: string;
  error?: string;
  onChange: (value: string) => void;
}

/**
 * Required Yes/No radio group with a label, red asterisk, and an inline
 * error slot. Used by the `mfa_present` and `is_active` radios — they
 * share an identical layout and option set, so this component centralizes
 * both the markup and the YES_NO_OPTIONS reference.
 */
export const YesNoRadio = ({
  label,
  name,
  value,
  error,
  onChange,
}: YesNoRadioProps) => (
  <div className="flex flex-col gap-2">
    <div className="mt-1 text-xs">
      {label}
      <span className="text-red-600"> *</span>
    </div>
    <RadioButton
      name={name}
      direction="horizontal"
      value={value}
      onChange={onChange}
      options={YES_NO_OPTIONS}
    />
    {error && <div className="text-xs text-red-600">{error}</div>}
  </div>
);
